class NativeApi {
  constructor() {
    this.jsbridgeReady = false;
    this.waitQueue = [];

    if (typeof TcsJSBridge == 'object' && typeof TcsJSBridge.invoke == 'function') {
      this.jsbridgeReady = true;
    } else {
      document.addEventListener('TcsJSBridgeReady', () => {
        this.jsbridgeReady = true;
        this.loopRun();
      }, false);
    }
  }
  log(...argu) {
    console.log(argu);
  }
  loopRun() {
    if (this.waitQueue.length == 0) {
      return;
    }
    const task = this.waitQueue.shift();
    console.log('queue, run, ', task[0], task[1]);
    this.run(task[0], task[1]);
    setTimeout(() => {
      this.loopRun();
    }, 200);
  }
  run(funcName, params) {
    if (typeof (this['_' + funcName]) == 'function') {
      if (this.jsbridgeReady) {
        this['_' + funcName].apply(this, params);
      } else {
        this.waitQueue.push([funcName, params]);
      }
    } else {
      this.log('api ', funcName, 'not exist!');
    }
  }
  _getMainAccountInfo(callback = () => { }) {
    TcsJSBridge.invoke('getMainAccountInfo', {}, (res) => {
      console.log('getMainAccountInfo', res);
      (!res || res.ret != 0) && this.log('getMainAccountInfo jsapi error:', res);
      callback(res);
    });
  }
  _getGalleryAccountStorageInfo(callback = () => { }) {
    TcsJSBridge.invoke('getGalleryAccountStorageInfo', {}, (res) => {
      console.log('getGalleryAccountStorageInfo', res);
      (!res || res.ret != 0) && this.log('getGalleryAccountStorageInfo jsapi error:', res);
      callback(res);
    });
  }
  _getQQLoginKey(aUin, aKeyType, callback = () => { }) {
    TcsJSBridge.invoke('getQQLoginKey', {
      uin: aUin,
      keytype: aKeyType
    }, (res) => {
      console.log('getQQLoginKey', res);
      (!res || res.ret != 0) && this.log('getQQLoginKey jsapi error:', res);
      callback(res);
    });
  }
  _getPlatform(callback = () => { }) {
    TcsJSBridge.invoke('platform', null, (res) => {
      console.log('platform', res);
      (!res || res.err_msg != 'ok') && this.log('platform jsapi error:', res);
      callback(res);
    });
  }
  _getInfo(aType, callback = () => { }) {
    console.log('getInfo___________________________');
    TcsJSBridge.invoke('getInfo', {
      key: aType
    }, (res) => {
      console.log('getinfo返回————————————————————', res);
      (!res || res.err_msg != 'ok') && this.log('getInfo jsapi error:', res);
      callback(res);
    });
  }
  _getReportUserActionTo3GFeature(id, callback = () => { }) {
    /* 客户端统计 UserAction */
    console.log('上报id——————————————————————', id);
    TcsJSBridge.invoke('reportUserActionTo3GFeature', {
      featureID: id
    }, (res) => {
      console.log('reportUserActionTo3GFeature', res);
      (!res || res.ret != 0) && this.log('jsapi error:', res);
      callback(res);
    });
  }
  _getVersionCode(callback = () => { }) {
    TcsJSBridge.invoke('getQQSecureVersionCode', null, (res) => {
      (!res || res.err_msg != 'ok') && this.log('getQQSecureVersionCode jsapi error:', res);
      console.log('get version code', res);
      callback(res);
    });
  }
  _getBuildNo(callback = () => { }) {
    TcsJSBridge.invoke('getQQSecureBuildNo', null, (res) => {
      (!res || res.err_msg != 'ok') && this.log('getQQSecureBuildNo jsapi error:', res);
      console.log('get buildno', res);
      callback(res);
    });
  }
  _notifyGalleryDidSelectPayService(opts, callback = () => { }) {
    /* 客户端统计 UserAction */
    TcsJSBridge.invoke('notifyGalleryDidSelectPayService', opts, (res) => {
      console.log('notifyGalleryDidSelectPayService', res);
      (!res || res.ret != 0) && this.log('jsapi error:', res);
      callback(res);
    });
  }
  _notifyGalleryServiceStartProductPayWithIAP(opts, cb = () => { }) {
    console.log('notifyGalleryServiceStartProductPayWithIAP', opts);
    TcsJSBridge.invoke('notifyGalleryServiceStartProductPayWithIAP', opts, (res) => {
      console.log('notifyGalleryDidSelectPaywithiapService', res);
      (!res || res.ret != 0) && this.log('jsapi error:', res);
      cb(res);
    });
  }
  _notifyGalleryDidPayServiceSuccess(param, cb) {
    const opts = {
      pays: param.pays,
      user: param.user
    };
    console.log('call notifyGalleryDidPayServiceSuccess ', param, opts);
    TcsJSBridge.invoke('notifyGalleryDidPayServiceSuccess', opts, function (res) {
      if (res.ret == 0) {
        console.log('notifyGalleryDidPayServiceSuccess----------------------');
        console.log(res);
      } else {
        console.log('notifyGalleryDidPayServiceSuccess err_msg: ' + res.err_msg + ' res.ret: ' + res.ret);
      }
      cb && cb(res);
    });
  }

  /**
	 * 下载接口,下载完后自动安装
	 * 输入参数：
	 * url:必填,下载链接
	 * pkgName:必填,应用包名
	 * categoryId:
	 * channel_id:渠道值，选填
	 * showname:下载过程显示的名字，默认用包名或链接MD5，选填
	 * extStr:拓展字段，选填
	 */
  download(aUrl, aPkg, aCategory) {
    TcsJSBridge.invoke('download', {
      url: aUrl,
      pkgName: aPkg,
      categoryId: aCategory,
    }, function (res) {
      console.log('download:', res);
    });
  }
  doStringEmid(emid, values) {
    TcsJSBridge.invoke('stringEmid', {
      emid,
      values: [values]// ["0","1"]
    }, function (res) {
      console.log('stringEmid:', res);
    });
  }
  login() {
    return new Promise((resolve, reject) => {
      TcsJSBridge.invoke('login', {
      }, function (res) {
        resolve(res);
      });
    });
  }
}
export default NativeApi;
